module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ROYAL PANOPLY.")]), _vm._v(" Copyright © 2003 by Carolly Erickson. All rights reserved. Printed in the United States of America. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Erickson, Carolly, 1943–"), _c('br'), _vm._v("     Royal panoply : brief lives of the English monarchs / Carolly Erickson.—1st St. Martin’s Press ed."), _c('br'), _vm._v("        p. cm."), _c('br'), _vm._v("     ISBN-13: 978-0-312-31643-3"), _c('br'), _vm._v("     ISBN-10: 0-312-31643-7"), _c('br'), _vm._v("     I. Great Britain—Kings and rulers—Biography. 2. Queens—Great Britain—Biography. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DA28.1.E68 2006"), _c('br'), _vm._v("941.009′9—dc22"), _c('br'), _vm._v("[B]")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("2006040544")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First published, in somewhat different form, by History Book Club, 1271 Avenue of the Americas, New York, N.Y. 10020.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First St. Martin’s Press Edition: May 2006")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("10  9  8  7  6  5  4  3  2  1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aee7d74c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312316433_epub_cop_r1.vue
// module id = 66
// module chunks = 0